/**
 * @generated SignedSource<<e64c30028b99ec20ba6b244c8675016e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLSmartSyncStatus = "ACTIVE" | "BACKFILLING" | "DISABLED" | "%future added value";
export type UpdateSmartSyncInput = {
  days?: number | null | undefined;
  enabled: boolean;
  integrationId: any;
};
export type GitLabIntegrationsDialogUpdateSmartSyncMutation$variables = {
  input: UpdateSmartSyncInput;
};
export type GitLabIntegrationsDialogUpdateSmartSyncMutation$data = {
  readonly updateSmartSync: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly id: any;
      readonly smartSyncSettings: {
        readonly backfillError: string | null | undefined;
        readonly days: number;
        readonly status: GraphQLSmartSyncStatus;
      } | null | undefined;
    } | null | undefined;
  };
};
export type GitLabIntegrationsDialogUpdateSmartSyncMutation = {
  response: GitLabIntegrationsDialogUpdateSmartSyncMutation$data;
  variables: GitLabIntegrationsDialogUpdateSmartSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSmartSyncPayload",
    "kind": "LinkedField",
    "name": "updateSmartSync",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSmartSyncSettings",
            "kind": "LinkedField",
            "name": "smartSyncSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "days",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backfillError",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GitLabIntegrationsDialogUpdateSmartSyncMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GitLabIntegrationsDialogUpdateSmartSyncMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c53c5a30597d7b23049c775aa01ea22",
    "id": null,
    "metadata": {},
    "name": "GitLabIntegrationsDialogUpdateSmartSyncMutation",
    "operationKind": "mutation",
    "text": "mutation GitLabIntegrationsDialogUpdateSmartSyncMutation(\n  $input: UpdateSmartSyncInput!\n) {\n  updateSmartSync(input: $input) {\n    integration {\n      id\n      smartSyncSettings {\n        days\n        status\n        backfillError\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "2925d127d9e4119413c0c9eef106de04";

export default node;
